import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import properties from '../properties';

export const formatKpiPrograms = (
  data: any,
  handleChange: any,
  handleSelectedValues: any,
) => {
  const formattedData = data?.map((item: any) => {
    return {
      program: item?.program,
      Kpis: item?.Kpis?.map((value: any) => {
        return {
          name: value?.name,
          values: value?.values,
          isChecked: false,
          handleChange,
          selectedValues: [],
          handleSelectedValues,
        };
      }),
    };
  });
  return formattedData;
};

export const getUrl = async (value: any) => {
  if (value === 'Total Cost') {
    return properties.totalCost;
  } else if (value === 'PEPM') {
    return properties.pepmTrend;
  } else if (value === 'PMPM') {
    return properties.pmpmTrend;
  } else if (value === 'Prevalence rate') {
    return properties.prevalenceRate;
  } else if (value === 'Quality Measure Performance') {
    return properties.qualityMeasure;
  } else {
    return '';
  }
};

export const getFormattedChartData = async (data: any, name: string) => {
  if (data.length) {
    return data.map((item: any) => [
      name === 'Quality Measure Performance'
        ? `${item.service_year}`
        : `${item.month}/${item.service_year}`,
      item.value,
    ]);
  } else {
    return [];
  }
};

export const combineTimeMarkers = async (
  implementationDate: string,
  additionalTimeMarkers: Array<any>,
) => {
  const updatedTimeMarkers = additionalTimeMarkers.filter(
    (item: any) => item.date !== '',
  );
  updatedTimeMarkers.push({
    name: 'Date of implementation',
    date: implementationDate,
  });
  return updatedTimeMarkers;
};

export const formatTimeMarkers = async (timeMarkers: Array<any>) => {
  if (timeMarkers?.length) {
    const updatedTimeMarkers = timeMarkers.map((item: any) => {
      return {
        start: item.date,
        label: item.name,
        timeFormat: '%b-%Y',
        style: {
          marker: {
            fill: patientAccessTheme.palette.warning[500],
          },
        },
      };
    });
    return updatedTimeMarkers;
  }
  return [];
};
